export default {
  pages: [],
  history: [],
  filterDate: '',
  activePage: null,
  requestStatus: 'loading',
  loadingHistory: true,
  historyIsLoaded: false,
};
